import React, { ReactElement } from 'react'
import { Flex, PandaButton } from '@mindfulchefuk/design-system'
import { AddSubtractQuantityButtonGroup } from '@mindfulchefuk/components/AddSubtractQuantityButtonGroup/AddSubtractQuantityButtonGroup'
import { PortionCount } from '@mindfulchefuk/config/portionCountConfig'
import { box } from 'styled-system/patterns'

export type TRecipeActionButtons = {
  isBasketFull: boolean
  onAddRecipe: () => void
  onSubtractRecipe: () => void
  quantityInBasket: number
  recipeTitle: string
  isModal: boolean
  portionCount?: PortionCount
}

export const RecipeActionButtons = ({
  isBasketFull,
  isModal,
  onAddRecipe,
  onSubtractRecipe,
  quantityInBasket,
  recipeTitle,
  portionCount,
}: TRecipeActionButtons): ReactElement => {
  const isDisplayingSingleButton = quantityInBasket === 0
  const buttonText = isBasketFull ? 'Box full' : 'Add'
  const buttonAriaLabel = isBasketFull
    ? 'No additional items can be added to the basket'
    : `Add ${recipeTitle} to your basket`

  const dataTestId = isModal ? 'recipe-modal-add-item' : 'recipe-card-add-item'

  return (
    <Flex
      alignItems="flex-end"
      height="100%"
      justifyContent={['center', 'flex-start']}
    >
      {isDisplayingSingleButton && (
        <div className={box({ height: 'fit-content' })}>
          <PandaButton
            aria-label={buttonAriaLabel}
            data-testid={dataTestId}
            onClick={(event) => {
              event.stopPropagation()
              onAddRecipe()
            }}
            disabled={isBasketFull}
            fullWidth
          >
            {buttonText.toUpperCase()}
          </PandaButton>
        </div>
      )}

      {!isDisplayingSingleButton && (
        <AddSubtractQuantityButtonGroup
          isAdditionDisabled={isBasketFull}
          isModal={isModal}
          itemName={recipeTitle}
          quantity={quantityInBasket}
          onAdd={onAddRecipe}
          onSubtract={onSubtractRecipe}
          showPortionAndQuantity={isModal}
          portionCount={portionCount}
        />
      )}
    </Flex>
  )
}
